import styled from 'styled-components'
import measures from 'globals/measures'

export const ClientDetailsWrapper = styled.div`
  height: 100%;
  display: flex;
`

export const ClientDetailsContent = styled.div`
  height: 100%;
  padding: 50px 48px 0;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media(max-width: ${measures.mobileThreshold}px) {
    padding: 16px 24px;
  }
`
